import Vue from 'vue';
import Component from 'vue-class-component';
import { Client } from '@/api/profile';
import REQ_URL from '@/consts/req-url';

@Component({
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if ((vm as ClientsDetail).$route.params.client) (vm as ClientsDetail).profile = JSON.parse((vm as ClientsDetail).$route.params.client)
            else (vm as ClientsDetail).setProfile(vm.$route.params.cid);
        })
    },
})
export default class ClientsDetail extends Vue {
    profile: Client | null = null
    async setProfile(cid: string) {
        this.$store.commit('modal:open', {
            type: 'loading',
            msg: 'Идёт загрузка'
        })
        try {
            let data = await this.$fetch<Client>(REQ_URL.GET_CLIENT, {
                method: 'post',
                body: JSON.stringify({
                    id: this.$route.params.cid
                })
            });
            if (data.body) this.profile = data.body
            else throw new Error(data.error)
        } catch (error) {
            console.log(error)
            return false
        }
        this.$store.commit('modal:close')
        return true
    }
}